// Import necessary libraries and components
import React, { useEffect, useState } from "react";

import AssistantImg from "../../../../assets/ai-tutor/assistant.svg";
import { Box } from "@chakra-ui/react";
import emotionalMessages from "../../../../utils/emotionalScriptConstants";
import { getRandomVinMessage } from "../../../../network/LearnApiService";
import pkg from "@inrscr/coschool-ui-components";
import styles from "./assistant.module.css";
import useStateRef from "react-usestateref";
import {
  getEmotionalMessageText,
  isNotEmptyOrNull } from
"../../../../utils/common-utils";
import { StorageService } from "../../../../utils/StorageUtils";

// Define the Assistant component
export default function Assistant({
  text,
  loader = false,
  hideVin = false,
  isDialogScript,
  scriptData,
  imagesList,
  isQuestion = false,
  questionType,
  emotionalMessageCode,
  assistantRefImages = [],
  showAllRefImages = false,
  isUser = false,
  isWelcomeClassifier = false,
  isEmotionalScript = false,
  audioPlayer = undefined,
  loaderText = "",
  isComprehension = false
}) {
  const { Assistant: AssistantUI } = pkg;

  const [assistantText, setAssistantText] = useState(); // Assistant's message text
  const [userDetails, setUserDetails, userDetailsRef] = useStateRef({}); // User details from local storage
  // const [isEmotionalScript, setIsEmotionalScript, isEmotionalScriptRef] =
  //   useStateRef(false);

  // Retrieve the assistant's message, replacing placeholders with actual data
  const getAssistantText = async () => {
    let assistantText = await getEmotionalMessageText(emotionalMessageCode);
    // Replace placeholder with student's name if present
    if (
    assistantText.includes("@@studentName") ||
    assistantText.includes("@@studentname"))
    {
      assistantText = assistantText.replace(
        /@@studentName|@@studentname/g,
        `${userDetailsRef.current?.firstName}`
      );
    }

    if (assistantText.includes("@@linebreak")) {
      assistantText = assistantText.replace(/\s*@@linebreak\s*/g, "\n");
    }
    // setIsEmotionalScript(true);
    return assistantText;
  };

  // Effect to load user details and fetch assistant text when component mounts or emotionalMessageCode changes
  useEffect(() => {
    // Load user details from local storage
    if (isNotEmptyOrNull(emotionalMessageCode)) {
      let details = StorageService.getItem("user_additional_details");
      details = typeof details === "object" ? details : JSON.parse(details);
      if (details) {
        setUserDetails(details);
      }
      // Fetch assistant text if emotionalMessageCode is provided
      fetchDynamicText();
    }
  }, [emotionalMessageCode]);

  const fetchDynamicText = async () => {
    if (emotionalMessageCode > 0) {
      const message = await getAssistantText();
      setAssistantText(message);
    }
  };
  return (
    <Box w="100%">
      <AssistantUI
        text={text}
        loader={loader}
        hideVin={hideVin}
        isQuestion={isUser ? false : isQuestion}
        assistantText={assistantText}
        isDialogScript={isDialogScript}
        scriptData={scriptData}
        imagesList={imagesList}
        assistantImg={AssistantImg}
        assistantStyle={styles}
        showAllRefImages={showAllRefImages || false}
        assistantRefImages={assistantRefImages || []}
        fromStudent={true}
        isUser={isUser}
        questionType={questionType}
        isEmotionalScript={isEmotionalScript}
        isWelcomeClassifier={isWelcomeClassifier}
        audioPlayer={audioPlayer}
        loaderText={loaderText}
        isComprehension={isComprehension} />

    </Box>);

}